import { render, staticRenderFns } from "./UserLogins.vue?vue&type=template&id=449ceb68&scoped=true&"
import script from "./UserLogins.vue?vue&type=script&lang=ts&"
export * from "./UserLogins.vue?vue&type=script&lang=ts&"
import style0 from "./UserLogins.vue?vue&type=style&index=0&id=449ceb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ceb68",
  null
  
)

export default component.exports